/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import styles from './ConsumptionCard.module.css';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap';
import { FloBasicAreaChart } from 'components';
import { FormattedConsumptionData } from 'model';

type ConsumptionCardProps = {
  consumptionData:  FormattedConsumptionData,
  isLoading:        boolean,
  timezone:         string,
}

export const ConsumptionCard: React.FC<ConsumptionCardProps> =  React.memo(({
  consumptionData,
  isLoading,
  timezone,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <Row>
        <Col xs="12">
          <Row>
            <Col xs="12"><span className={styles.title}>{t('Water Consumption')}</span></Col>
          </Row>
          <Row>
            <Col className={styles.chartWrapper} xs="12">
              <FloBasicAreaChart
                style       = {{ height: '440px' }}
                yAxisLabel  = {consumptionData.unitSystem}
                xAxisData   = {consumptionData.xAxis}
                series      = {[{
                  name: 'Water Consumption',
                  data: consumptionData.values
                }]}
                formatter   = {consumptionData.formatter}
                isLoading   = {isLoading}
              />
            </Col>
          </Row>
          <Row>
            <Col className={styles.timezoneInfo} xs="12">
              <span className={styles.timezoneLabel}>{t('Timezone')}:</span>
              <span className={styles.timezoneValue}>{timezone}</span>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
});